const breakpoint = () => {
  const htmlWidth = document.querySelector("html").clientWidth;

  if (htmlWidth < 768) {
    return "mobile";
  }
  if (htmlWidth < 1024) {
    return "tablet";
  }
  return "desktop";
};

export default breakpoint;
